import { Outlet, useLocation } from "react-router-dom";

import { Box, Container } from "@mantine/core";

import Breadcrumbs from "./Breadcrumbs";

const MainContentContainer: React.FC = () => {
  const location = useLocation();
  const isHome = location.pathname === "/";

  return (
    <Box component="main" style={{ flex: 1, width: "100%" }}>
      {isHome ? (
        <Outlet />
      ) : (
        <Container size="xl" py={{ base: "md", sm: "xl" }}>
          <Box mb="lg">
            <Breadcrumbs />
          </Box>
          <Outlet />
        </Container>
      )}
    </Box>
  );
};

export default MainContentContainer;
